<template>
   <div
      id="used-by"
      :class="breakpoint">
      <div :class="containerClass">
         <div class="row">
            <div class="col-md-6">
               <h2 class="text-center text-md-start">Sådan virker Findforsikring</h2>
               <wistia-player video-id="q7uqhigqf8" />
            </div>
            <div
               class="col-md-1"
               style="min-height: 30px" />
            <div class="col-md-5">
               <div
                  id="used-by-content"
                  class="d-flex flex-column text-center text-md-start"
                  :class="{ 'items-center': lte('sm') }">
                  <h2 class="">Brugt af flere end...</h2>
                  <div>
                     <div
                        class="amount"
                        v-text="usedBy" />
                  </div>
                  <div>
                     Personer har brugt Findforsikring.dk
                     <br />
                     til at få bedre og billigere forsikringstilbud.
                  </div>
               </div>
            </div>
         </div>
      </div>
   </div>
</template>

<script>
import { mapGetters } from 'vuex';
import WistiaPlayer from '@/components/WistiaPlayer';

export default {
   name: 'MaterialUsedByOld',
   components: { WistiaPlayer },
   computed: {
      ...mapGetters(['breakpoint', 'containerClass', 'lte']),
      usedBy() {
         return this.$store.getters.stats.usedBy;
      },
      headingSize() {
         switch (this.breakpoint) {
            case 'md':
               return '160%';
            default:
               return '200%';
         }
      },
   },
};
</script>

<style lang="scss" scoped>
#used-by {
   padding: 3em;
   font-size: 17px;
   color: var(--ff-dark-blue);
   line-height: 1.5;

   &.xs {
      font-size: 13px;
   }

   #used-by-content {
      > *:not(:first-child) {
         margin-top: 1.5em;

         &:nth-child(2) {
            //margin-top: 2.5em;
         }
      }

      .amount {
         font-family: 'Lato', sans-serif;
         font-weight: bold;
         font-size: 450%;
         line-height: 1;
         color: var(--ff-dark-blue);
      }
   }

   .col-content {
      &.xl,
      &.lg,
      &.md {
         padding: 20px 0 !important;
      }

      &.sm,
      &.xs {
         padding: 2em !important;
      }
   }
}
</style>
